import { useEffect } from "react";

const FONT_ID = "tra-canonical-fonts";
const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600;700&family=Geist+Mono:wght@400;500;600&display=swap";

/**
 * Loads canonical TRA typography (Geist + Geist Mono) once for the whole app.
 * Source of truth: Visual v2 / approved app screenshots
 * (`reference_files/App_screenshots`).
 */
export function ensureCanonicalFonts() {
  if (typeof document === "undefined") return;
  if (document.getElementById(FONT_ID)) return;
  const pre = document.createElement("link");
  pre.rel = "preconnect";
  pre.href = "https://fonts.googleapis.com";
  pre.id = `${FONT_ID}-preconnect`;
  document.head.appendChild(pre);
  const link = document.createElement("link");
  link.id = FONT_ID;
  link.rel = "stylesheet";
  link.href = FONTS_URL;
  document.head.appendChild(link);
}

/** React hook — safe to call from any screen; loads fonts once. */
export function useCanonicalFonts() {
  useEffect(() => {
    ensureCanonicalFonts();
  }, []);
}
